import React from 'react';

const App = () => {
  window.location.href = "https://admin.gold-race.org/volunteers";

  return <></>;
};

export default App;
